export default {
    general: {
        add: 'Add',
        edit: 'Edit',
        save: 'Save',
        cancel: 'Cancel',
        delete: 'Delete',
        actions: 'Actions',
        search: 'Search',
        active: 'Active',
        yes: 'Yes',
        no: 'No',
        empty: 'No records found',
        loading: 'Loading…',
    },
    auth: {
        sign_in: 'Sign in',
        username: 'Username',
        password: 'Password',
        welcome: 'TimeTerminal Admin',
        subtitle: 'Sign in to manage your terminals',
        invalid_credentials: 'Invalid username or password',
    },
    nav: {
        users: 'Users',
        projects: 'Projects',
        devices: 'Devices',
        module_types: 'Module types',
        managed_play: 'App store',
        data: 'Data',
        logout: 'Log out',
        coming_soon: 'Coming soon',
        audit_card_reads: 'Card Reads',
        audit_exchanges: 'ERP Exchanges',
        audit_events: 'Device Events',
    },
    user: {
        users: 'Users',
        user: 'User',
        add: 'Add user',
        edit: 'Edit user',
        username: 'Username',
        email: 'Email',
        password: 'Password',
        new_password: 'New password (leave blank to keep current)',
        role: 'Role',
        projects: 'Projects',
        active: 'Active',
        last_login: 'Last login',
        confirm_delete: 'Delete this user?',
    },
    project: {
        projects: 'Projects',
        project: 'Project',
        add: 'Add project',
        edit: 'Edit project',
        name: 'Name',
        description: 'Description',
        active: 'Active',
        confirm_delete: 'Delete this project?',
    },
    device: {
        name: 'Name',
        project: 'Project',
        module_type: 'Module',
        state: 'State',
        config: 'Config',
        add: 'Add device',
        provision: 'Provision',
        overview: 'Overview',
        provisioning: 'Provisioning',
        diagnostics: {
            tab:               'Diagnostics',
            snapshot:          'Current Snapshot',
            battery:           'Battery',
            charging:          'Charging',
            not_charging:      'Not charging',
            network:           'Network',
            online:            'Online',
            not_online:        'Offline',
            storage:           'Storage',
            storage_format:    '{free} GB free of {total} GB',
            app_version:       'App version',
            queue_depth:       'Offline queue',
            last_seen:         'Last seen',
            heartbeat_at:      'Last heartbeat',
            amp_status_at:     'Last AMP status',
            history:           'History',
            history_collected: 'Collected',
            history_source:    'Source',
            history_battery:   'Battery',
            history_network:   'Network',
            history_queue:     'Queue',
            source_heartbeat:  'Heartbeat',
            source_amp_status: 'AMP status',
            no_data:           'No diagnostic data available yet',
            never:             'Never',
        },
        desired_config: 'Desired config version',
        reported_config: 'Reported config version',
        config_status: 'Config status',
        config_up_to_date: 'Up to date',
        config_restart_pending: 'Restart pending',
        restart: {
            button:  'Restart app',
            confirm: 'Restart the app on this device to apply the latest config? The device returns to the idle screen.',
            header:  'Restart device app',
            success: 'Restart requested — the device will re-apply its config shortly',
            error:   'Failed to request restart',
        },
        decommission: {
            button:  'Decommission',
            confirm: 'Are you sure you want to decommission this device? This action cannot be undone.',
            header:  'Decommission Device',
            success: 'Device decommissioned successfully',
            error:   'Failed to decommission device',
        },
    },
    device_state: {
        created: 'Created',
        enrolling: 'Enrolling',
        enrolled: 'Enrolled',
        active: 'Active',
        offline: 'Offline',
        decommissioned: 'Decommissioned',
    },
    provision: {
        title: 'Provision device',
        scan_instructions: 'Factory-reset the tablet, then scan this QR code to enroll it.',
        expires_in: 'Expires in',
        waiting: 'Waiting for the device to enroll…',
        enrolled: 'Device enrolled',
        not_configured: 'Provisioning is not configured on the server (Android Management API).',
        dev_connect: 'Developer connection (debug builds)',
        dev_connect_help: 'Scan this in the app\'s Developer connection screen to link without AMAPI.',
    },
    config: {
        title: 'Device configuration',
        version: 'Version',
        override: 'Override app-version check',
        upload_legacy: 'Upload current config',
        app_version_gate: 'Blocked: the device app is older than this schema requires. Enable override to save anyway.',
        imported: 'Legacy config imported — review and save',
        import_failed: 'Could not import the uploaded config',
        unsupported_module: 'No config editor for module type "{module}".',
    },
    managed_play: {
        title: 'App store',
        subtitle: 'Publish and manage the terminal app in your organization\'s managed Google Play.',
        token_failed: 'Could not open managed Google Play (provisioning may be disabled).',
        gapi_failed: 'Could not load Google APIs — check your network and ad blockers.',
        update_title: 'App version',
        update_help: 'Enforce a minimum app version across all devices. Leave the time empty to apply now, or pick a time to schedule it.',
        current_version: 'Enforced version',
        version_code: 'Target version code',
        apply_at: 'Apply at',
        now: 'Now',
        scheduled: 'Scheduled',
        update_applied: 'App version updated.',
        update_failed: 'Could not update the app version.',
    },
    probit: {
        title: 'ProBit configuration',
        erp: 'ERP connection',
        server_url: 'Server URL',
        event_path: 'Event path',
        info_path: 'Worker info path',
        worker_plan_path: 'Worker plan path',
        company_id: 'Company ID',
        identifiers: 'Identifiers',
        terminal_id: 'Terminal ID',
        default_location_id: 'Default location ID',
        heimdall: 'Heimdall (door control)',
        heimdall_url: 'Heimdall URL',
        heimdall_api_key: 'Heimdall API key',
        ui: 'Appearance',
        background_color: 'Background color',
        current_plan_background_color: 'Current plan color',
        next_plan_background_color: 'Next plan color',
        other_cost_center_background_color: 'Other cost-center color',
        behavior: 'Behavior',
        selection_type: 'Selection mode',
        selection_type_a: 'Mode A',
        selection_type_b: 'Mode B',
        info_on_every_action: 'Show info on every action',
        show_nfc_sign: 'Show NFC prompt',
        nfc_sign_position: 'NFC prompt position (screen quarter)',
        nfc_pos_top_left: 'Top left',
        nfc_pos_top_right: 'Top right',
        nfc_pos_bottom_left: 'Bottom left',
        nfc_pos_bottom_right: 'Bottom right',
        timeouts: 'Timeouts (ms)',
        event_clear_ms: 'Event clear',
        info_clear_ms: 'Info clear',
        cost_center_auto_back_ms: 'Cost-center auto back',
        actions: 'Actions',
        action_title: 'Title',
        action_event_id: 'Event ID',
        action_color: 'Color',
        action_icon_color: 'Icon color',
        action_icon: 'Icon',
        action_info_button: 'Info button',
        action_heimdall_terminal: 'Heimdall terminal',
        action_cost_center_selection: 'Cost-center selection',
        action_location_id: 'Location ID',
    },
    role: {
        admin: 'Administrator',
        user: 'User',
    },
    audit: {
        card_reads: 'Card Reads',
        exchanges: 'ERP Exchanges',
        events: 'Device Events',
        outcome: 'Outcome',
        outcome_idle_scan: 'Idle scan',
        outcome_info: 'Info',
        outcome_action: 'Action',
        outcome_failed: 'Failed',
        card_uid: 'Card UID',
        occurred_at: 'Time',
        device: 'Device',
        result_status: 'Result',
        replayed: 'Replayed',
        action_event_id: 'Action',
        operation: 'Operation',
        request_method: 'Method',
        request_url: 'URL',
        response_status: 'Status',
        latency_ms: 'Latency (ms)',
        event_type: 'Event type',
        from: 'From',
        to: 'To',
        correlation: 'Correlation chain',
        exchange_detail: 'Exchange detail',
        request_headers: 'Request headers',
        response_headers: 'Response headers',
        request_body: 'Request body',
        response_body: 'Response body',
        empty_body: '(empty)',
        filter_project: 'Project',
        filter_device: 'Device',
        filter_outcome: 'Outcome',
        filter_from: 'From date',
        filter_to: 'To date',
        all_projects: 'All projects',
        all_devices: 'All devices',
        all_outcomes: 'All outcomes',
    },
    errors: {
        generic_error: 'An error occurred',
        invalid_data: 'Invalid data',
        not_found: 'Not found',
        unauthorized: 'Unauthorized',
        conflict: 'Already exists',
        on_add: 'Error while adding',
        on_edit: 'Error while updating',
        on_delete: 'Error while deleting',
        load_failed: 'Failed to load data',
    },
    success: {
        add: 'Successfully added',
        edit: 'Successfully updated',
        delete: 'Successfully deleted',
    },
}
